define('Plans.ei1.PlansPage.View', [
    'PageType.Base.View',
    'plans_page.tpl',
    'jQuery',
    'SC.Configuration',
    'Planspage.ei1.Main.Model'
], function (
    PageTypeBaseView,
    plans_page_tpl,
    jQuery,
    Configuration,
    PlanspageModel
) {
    'use strict';

    var IMAGE_BASE_URL = 'https://1homeoffice.com';

    function buildImageUrl(thumbnailPath) {
        if (!thumbnailPath) return '';
        if (thumbnailPath.indexOf('http') === 0) return thumbnailPath;
        return IMAGE_BASE_URL + thumbnailPath;
    }

    var SLUG_MAP = {
        'inner courtyard': 'innercourtyard',
        'long courtyard': 'longcourtyard',
        'trenza marmi room': 'trenza',
        'courtyard room': 'courtyard',
        'the courtyard room': 'courtyard',
        'carrara room': 'carrara',
        'boston stone room': 'boston',
        'workstation': 'workstation',
        'workstations': 'workstation',
        'alcoves': 'alcoves',
        'serpentine alcove': 'serpentine',
        'travertine alcove': 'travertine',
        'pietra alcove': 'pietra',
        'palladio alcove': 'palladio',
        'foyer alcove': 'foyer'
    };

    function buildRoomUrl(name) {
        var key = (name || '').toLowerCase().trim();
        var slug = SLUG_MAP[key];
        return slug ? '/room/' + slug : '#';
    }

    function processChild(child) {
        return {
            name: child.name || '',
            imageUrl: buildImageUrl(child.thumbnail || ''),
            roomUrl: buildRoomUrl(child.name),
            description: child.description || ''
        };
    }

    return PageTypeBaseView.PageTypeBaseView.extend({
        template: plans_page_tpl,

        initialize: function (options) {
            PageTypeBaseView.PageTypeBaseView.prototype.initialize.apply(this, arguments);

            var self = this;
            self.options = options || {};

            var container = self.options.container;
            self.cartComponent = container
                ? container.getComponent('Cart')
                : null;

            window.__plansView = self;
            self.workstationItems = [];
            self.alcoveItems = [];
            self.conferenceItems = [];

            self.addedItemIds = [];
            self.itemQuantities = {};

            // ── Find Your Space data ─────────────────────────────────────
            self.meetingRooms = [];
            self.alcoveRooms = [];
            self.workstationRoom = null;
            self.findSpaceRowOne = [];
            self.findSpaceRowTwo = [];

            self.itemsReady = false;
            self.findSpaceReady = false;
            self.hasRendered = false;

            var currentHash = window.location.hash.toLowerCase();
            var currentPath = window.location.pathname.toLowerCase();
            self.isMeetingPass = currentHash.indexOf('meetingpass') !== -1 ||
                currentPath.indexOf('meetingpass') !== -1;

            // ── Add to cart (cart icon) ────────────────────────────────
            // self.addToCart = function (itemId, iconBtn) {
            //     if (!self.cartComponent) return;
            //     if (iconBtn) { iconBtn.disabled = true; }

            //     self.cartComponent.addLines({
            //         lines: [{ item: { internalid: itemId }, quantity: 1 }]
            //     })
            //         .then(function () {
            //             self.itemQuantities[itemId] = (self.itemQuantities[itemId] || 0) + 1;
            //             self.updateCartBadge(itemId, self.itemQuantities[itemId]);
            //             if (iconBtn) { iconBtn.disabled = false; }
            //         })
            //         .catch(function (err) {
            //             console.error('[PlansPage] addToCart error:', err);
            //             if (iconBtn) { iconBtn.disabled = false; }
            //         });
            // };
            // ── Add to cart (single button) ─────────────────────────────
            self.addToCart = function (itemId, btn) {
                if (!self.cartComponent) return;
                if (btn) { btn.disabled = true; }
                self.cartComponent.addLines({
                    lines: [{ item: { internalid: itemId }, quantity: 1 }]
                })
                    .then(function () {
                        self.itemQuantities[itemId] = (self.itemQuantities[itemId] || 0) + 1;
                        self.updateCartBadge(itemId, self.itemQuantities[itemId]);
                        if (btn) { btn.disabled = false; }
                        return self.cartComponent.triggerAddToCartConfirmation();
                    })
                    .catch(function (err) {
                        console.error('[PlansPage] addToCart error:', err);
                        if (btn) { btn.disabled = false; }
                    });
            };
            // ── Checkout (checkout button) ───────────────────────────────
            // self.handleCheckout = function (itemId, btn) {
            //     var checkoutUrl = '/sca-dev-2026-1-0/checkout.ssp?is=checkout';
            //     window.location.href = checkoutUrl;
            // };

            self.fetchServiceItems();
            self.fetchFindSpaceData();
        },

        fetchServiceItems: function fetchServiceItems() {
            var self = this;

            jQuery.ajax({
                url: '/api/items',
                method: 'GET',
                data: {
                    fieldset: 'details',
                    itemtype: 'Service',
                    limit: 100,
                    offset: 0,
                    fields: 'custitem_ei1_duration_per_pack'
                },

                success: function (response) {
                    if (response.items && response.items.length) {
                        response.items.forEach(function (item) {
                            var itemClass = item.class || '';

                            var price = item.onlinecustomerprice_detail
                                ? item.onlinecustomerprice_detail.onlinecustomerprice
                                : 0;

                            // custom field may come back as a raw value or {value, text} depending on field type
                            var rawDuration = item.custitem_ei1_duration_per_pack;
                            var durationPerPack = (rawDuration && rawDuration.value !== undefined)
                                ? parseFloat(rawDuration.value)
                                : parseFloat(rawDuration);

                            var displayPrice = price;
                            if (durationPerPack && durationPerPack > 0) {
                                displayPrice = Math.round(parseFloat(price) / durationPerPack);
                            }

                            var mapped = {
                                passType: item.displayname || '',
                                passTypeDescription: item.storedetaileddescription || '',
                                subheader: item.pagetitle || '',
                                headerDescription: item.featureddescription || '',
                                cardHeader: item.storedisplayname || '',
                                cardDescription: item.storedescription || '',
                                cardSubheader: item.salesdescription || '',
                                price: price,
                                displayPrice: displayPrice,
                                durationPerPack: durationPerPack || null,
                                internalid: item.internalid
                            };

                            if (itemClass.indexOf('Work Station') !== -1) {
                                self.workstationItems.push(mapped);
                            } else if (itemClass.indexOf('Alcove') !== -1) {
                                self.alcoveItems.push(mapped);
                            } else if (itemClass.indexOf('Conference Room') !== -1) {
                                self.conferenceItems.push(mapped);
                            }
                        });

                        function sortByPrice(arr) {
                            return arr.sort(function (a, b) {
                                return parseFloat(a.price) - parseFloat(b.price);
                            });
                        }

                        // ── Compute "Standard Rate" / "Save $X" badge data ──────────
                        // The item with the LOWEST price in the group is the standard-rate
                        // reference (single-unit purchase). For every other (bulk/pack) item,
                        // the savings shown is: (item's duration multiplier * standard item's
                        // price) - the item's own price. This is fully dynamic: if any item's
                        // price or duration field changes in NetSuite, the savings recompute
                        // automatically with no code changes needed.
                        function computeSavings(items) {
                            if (!items || !items.length) return items;

                            var standardItem = items[0]; // lowest price after sortByPrice
                            var standardPrice = parseFloat(standardItem.price) || 0;

                            items.forEach(function (item, index) {
                                if (index === 0) {
                                    item.isStandardRate = true;
                                    item.savings = null;
                                    return;
                                }

                                item.isStandardRate = false;

                                var duration = parseFloat(item.durationPerPack);
                                var itemPrice = parseFloat(item.price);

                                if (duration && standardPrice && !isNaN(itemPrice)) {
                                    var expectedCostAtStandardRate = duration * standardPrice;
                                    var savings = expectedCostAtStandardRate - itemPrice;
                                    // Only show a savings badge if it's a genuine positive saving
                                    item.savings = (savings > 0) ? Math.round(savings) : null;
                                } else {
                                    item.savings = null;
                                }
                            });

                            return items;
                        }

                        self.workstationItems = computeSavings(sortByPrice(self.workstationItems));
                        self.alcoveItems = computeSavings(sortByPrice(self.alcoveItems));
                        self.conferenceItems = computeSavings(sortByPrice(self.conferenceItems));
                    }

                    self.itemsReady = true;
                    self.tryRender();
                },
                error: function (err) {
                    console.error('[PlansPage] Item Search API Error:', err);
                    self.itemsReady = true;
                    self.tryRender();
                }
            });
        },

        // ── Find Your Space: fetch + process category tree ──────────────
        fetchFindSpaceData: function fetchFindSpaceData() {
            var self = this;

            self.PlanspageModel = new PlanspageModel();
            self.PlanspageModel.fetch()
                .done(function () {
                    var response = self.PlanspageModel.toJSON();
                    var categories = (response && response.data) ? response.data : [];
                    var mainCategory = (categories && categories.length) ? categories[0] : {};
                    var rawSubCategories = mainCategory.subCategories || [];

                    rawSubCategories.forEach(function (subCat) {
                        if ((subCat.name || '').toLowerCase().indexOf('coworking') === -1) return;

                        var rawChildren = subCat.subCategories || [];

                        rawChildren.forEach(function (child) {
                            var childName = (child.name || '').toLowerCase().trim();

                            if (childName.indexOf('meeting') !== -1) {
                                var rooms = child.subCategories || [];
                                self.meetingRooms = rooms.map(processChild);

                            } else if (childName.indexOf('workspace') !== -1 ||
                                childName.indexOf('work space') !== -1) {
                                var workspaceChildren = child.subCategories || [];

                                workspaceChildren.forEach(function (ws) {
                                    var wsName = (ws.name || '').toLowerCase().trim();

                                    if (wsName.indexOf('alcove') !== -1) {
                                        var alcoveItems = ws.subCategories || [];
                                        self.alcoveRooms = alcoveItems.map(processChild);

                                    } else if (wsName.indexOf('workstation') !== -1) {
                                        self.workstationRoom = processChild(ws);
                                    }
                                });
                            }
                        });
                    });

                    var alcoveGroup = self.workstationRoom
                        ? self.alcoveRooms.concat([self.workstationRoom])
                        : self.alcoveRooms;

                    // Daypass page  -> Row1: Alcoves + Workstation, Row2: Meeting Rooms
                    // Meeting page  -> Row1: Meeting Rooms, Row2: Alcoves + Workstation
                    if (self.isMeetingPass) {
                        self.findSpaceRowOne = self.meetingRooms;
                        self.findSpaceRowTwo = alcoveGroup;
                    } else {
                        self.findSpaceRowOne = alcoveGroup;
                        self.findSpaceRowTwo = self.meetingRooms;
                    }

                    self.findSpaceReady = true;
                    self.tryRender();
                })
                .fail(function (err) {
                    console.error('[PlansPage] FindSpace Model fetch error:', err);
                    self.findSpaceReady = true;
                    self.tryRender();
                });
        },

        // ── Render once both data sources are in ────────────────────────
        tryRender: function tryRender() {
            var self = this;
            if (!self.itemsReady || !self.findSpaceReady || self.hasRendered) return;

            self.hasRendered = true;
            self.render();
            self.fetchCartQuantities();
        },

        fetchCartQuantities: function fetchCartQuantities() {
            var self = this;

            if (!self.cartComponent) return;

            self.cartComponent.getLines()
                .then(function (lines) {
                    if (!lines || !lines.length) return;

                    lines.forEach(function (line) {
                        var itemId = line.item && line.item.internalid
                            ? line.item.internalid.toString()
                            : null;

                        if (itemId && line.quantity > 0) {
                            self.itemQuantities[itemId] = line.quantity;
                        }
                    });

                    self.refreshAllBadges();
                })
                .catch(function (err) {
                    console.error('[PlansPage] fetchCartQuantities error:', err);
                });
        },

        refreshAllBadges: function refreshAllBadges() {
            var self = this;
            Object.keys(self.itemQuantities).forEach(function (itemId) {
                self.updateCartBadge(itemId, self.itemQuantities[itemId]);
            });
        },

        updateCartBadge: function updateCartBadge(itemId, qty) {
            var card = document.querySelector('.price-card[data-item-id="' + itemId + '"]');
            if (!card) return;
            var badge = card.querySelector('.cart-qty-badge');
            if (!badge) return;

            if (qty > 0) {
                badge.textContent = qty;
                badge.classList.add('visible');
                var iconBtn = card.querySelector('.cart-icon-btn');
                if (iconBtn) { iconBtn.classList.add('in-cart'); }
            } else {
                badge.textContent = '0';
            }
        },

        getContext: function getContext() {
            return {
                workstationItemsJson: JSON.stringify(this.workstationItems),
                alcoveItemsJson: JSON.stringify(this.alcoveItems),
                conferenceItemsJson: JSON.stringify(this.conferenceItems),
                findSpaceRowOneJson: JSON.stringify(this.findSpaceRowOne),
                findSpaceRowTwoJson: JSON.stringify(this.findSpaceRowTwo),
                isMeetingPass: this.isMeetingPass
            };
        }
    });
});
